export const state = {
  addLocation: {
    userName: '',
    phoneNumber: '',
    foothold: true
  },
  updateLocation: {},
  location: {
    userName: '',
    phoneNumber: ''
  },
  locations: [],
  exportData: [],
  total: 0,
  selectedLocationList: []
}
export const mutations = {
  setLocations(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedLocationList.some(
          selectedLocation =>
            selectedLocation.userId === response.data['data'][i]['userId']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
      response.data['data'][i]['foothold'] = true
    }
    state.locations = response.data['data']
    state.total = response.data['header']['total']
  },
  setExportData(state, response) {
    for (var i = 0; i < response.data['data'].length; i++) {
      let date = new Date(response.data['data'][i]['createDateTime'])
      response.data['data'][i]['createDateTime'] =
        date.getFullYear() +
        '/' +
        (date.getMonth() + 1) +
        '/' +
        date.getDate() +
        ' ' +
        date.toLocaleTimeString()
      date = new Date(response.data['data'][i]['lastUpdateDateTime'])
      response.data['data'][i]['lastUpdateDateTime'] =
        response.data['data'][i]['lastUpdateDateTime'] === null
          ? ''
          : date.getFullYear() +
            '/' +
            (date.getMonth() + 1) +
            '/' +
            date.getDate() +
            ' ' +
            date.toLocaleTimeString()
    }
    state.exportData = response.data['data']
  },
  clearExportData(state) {
    state.exportData = []
  },
  setDetail(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    response.data['data'][0]['foothold'] = true
    state.location = response.data['data'][0]
    state.updateLocation = {}
    state.updateLocation.userId = state.location.userId
    state.updateLocation.deviceId = state.location.deviceId
  },
  inputUpdate(state, payload) {
    state.updateLocation[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addLocation[payload.name] = payload.value
  },
  clearLocation(state) {
    state.addLocation = {}
  },
  updateSelectedLocationList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedLocationList.some(
          user => user.userId === payload[i].userId
        )
      ) {
        state.selectedLocationList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedLocationList.some(
          user => user.userId === payload[i].userId
        )
      ) {
        const deleteIndex = state.selectedLocationList.findIndex(
          user => user.userId === payload[i].userId
        )
        state.selectedLocationList = state.selectedLocationList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedLocationList(state) {
    state.selectedLocationList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/placeModules/placeMutation.js